import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'
import { ThemeProvider } from 'styled-components'

import { ConfigWrapper } from 'aem-libs-react-components/src/components/core/ConfigWrapper'
import { InletErrorBoundary } from 'aem-libs-react-components/src/components/core/InletErrorBoundery'
import { InletWrapper } from 'aem-libs-react-components/src/components/core/InletWrapper'
import { FallbackError } from 'aem-libs-react-components/src/components/core/fallback-error'
import type { ParamsFunctionResolver } from 'aem-libs-react-components/src/components/core/parseDynamicParams'
import { AppContextProvider } from 'aem-libs-react-components/src/contexts/AppContextProvider'
import GlobalStyle from 'aem-libs-react-components/src/styles/globalStyle'
import { csasTheme } from 'aem-libs-react-components/src/styles/theme'

import type { StaticParamsBase } from '../types/common'
import { Inlet } from './Inlet'
import type { LoggingOptions } from 'aem-libs-react-components/src/contexts/AppContextProvider/types'

export interface RenderOptions<T> {
  viewTracking?: boolean
  rootId?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parseDynamicParams?: ParamsFunctionResolver
  onFetchParams?: <StaticParams extends StaticParamsBase>(params: T, staticParams: StaticParams) => void
  logging?: LoggingOptions
}

export function renderApp<T>(inletInstance: Inlet, AppElement: React.ComponentType, options?: RenderOptions<T>) {
  const root = ReactDOM.createRoot(inletInstance.appElement)

  root.render(
    <StrictMode>
      <ThemeProvider theme={csasTheme}>
        <AppContextProvider inlet={inletInstance} loggingOptions={options?.logging}>
          <InletErrorBoundary>
            <InletWrapper viewTracking={options?.viewTracking} rootId={options?.rootId}>
              <ConfigWrapper
                parseDynamicParams={options?.parseDynamicParams}
                renderError={() => <FallbackError />}
                onFetchParams={(params: T) =>
                  options?.onFetchParams && options.onFetchParams(params, inletInstance.getStaticParams())
                }
              >
                <AppElement />
              </ConfigWrapper>
            </InletWrapper>
          </InletErrorBoundary>
        </AppContextProvider>
        <GlobalStyle />
      </ThemeProvider>
    </StrictMode>
  )
}
